import { useGetDonorsQuery } from 'services/donors/api';
import { DonorsQueryParams } from 'services/donors/types';

export const useDonorsData = (params: DonorsQueryParams, skip: boolean) => {
  const { data, isLoading, isFetching } = useGetDonorsQuery(params, { skip });

  return {
    data,
    donors: data?.donors_totals ?? [],
    isLoading: isLoading || isFetching,
  };
};
